import { Mitarbeiter_RotationsplanVorlageDauerEinheit } from '@/gql/graphql';

export type Dauer = {
  dauer: number;
  dauerEinheit: Mitarbeiter_RotationsplanVorlageDauerEinheit;
};

export type Gesamtdauer = {
  monate: number;
  // true, sobald Wochen oder Tage beteiligt sind und die Monate gerundet wurden
  ungefaehr: boolean;
};

const TAGE_PRO_WOCHE = 7;
// Nur für die Anzeige: die Zeitraumberechnung rechnet nie in Tagesäquivalenten
const TAGE_PRO_MONAT = 30;

// Mit Wochen oder Tagen hängt die tatsächliche Länge vom Startdatum ab, daher
// werden Monate und Tage getrennt summiert und für die Anzeige zu ganzen
// Monaten zusammengefasst (kaufmännisch gerundet, ohne Resttage).
export function getGesamtdauer(stationen: Dauer[]): Gesamtdauer {
  let monate = 0;
  let tage = 0;

  for (const { dauer, dauerEinheit } of stationen) {
    switch (dauerEinheit) {
      case Mitarbeiter_RotationsplanVorlageDauerEinheit.Monate:
        monate += dauer;
        break;
      case Mitarbeiter_RotationsplanVorlageDauerEinheit.Wochen:
        tage += dauer * TAGE_PRO_WOCHE;
        break;
      case Mitarbeiter_RotationsplanVorlageDauerEinheit.Tage:
        tage += dauer;
        break;
    }
  }

  if (tage === 0) {
    return { monate, ungefaehr: false };
  }

  const gesamtTage = monate * TAGE_PRO_MONAT + tage;

  return {
    monate: Math.floor((gesamtTage + TAGE_PRO_MONAT / 2) / TAGE_PRO_MONAT),
    ungefaehr: true,
  };
}
